import { AppType, DeskApp } from '@/types/desk';
import { RouterInfo, RouteInfo, RouterObj } from '@/store/modules/app-manager/types';

let id = 10001;

export default class App {
    _configs: DeskApp;
    instanceId: number;
    loaded: boolean;
    outsideAppTag: boolean;
    routerInfo: RouterInfo | Record<string, never>;
    routeInfo: RouteInfo | Record<string, never>;

    constructor(
        configs: DeskApp,
        routerInfo: RouterInfo | Record<string, never>,
        routeInfo: RouteInfo | Record<string, never>
    ) {
        this._configs = configs;
        this.instanceId = id++;
        this.loaded = true;
        this.outsideAppTag = configs?.type === AppType.EXTERNAL_LINK_APP;
        this.routerInfo = routerInfo || {};
        this.routeInfo = routeInfo || {};
    }

    get url(): string {
        let url;
        // 前置条件必须设置一下route Info
        if (this.testHasRouteInfo()) {
            // 从外界跳入页面, 刷新
            url = this.getIframeUrlFromRouteInfo();
        } else {
            // 初始化
            url = this.getInitIframeUrl();
        }

        url = this.addTokenToIframeUrl(url);
        url = this.addRandomString(url);
        return url;
    }

    getIframeUrlFromRouteInfo(): string {
        let url = this.getInitIframeUrl();
        if (!this.routerInfo || !this.routeInfo) {
            return url;
        }
        if (this.routerInfo.type === 'hash') {
            url += '#';
        }
        url += this.routeInfo.fullPath;
        return url;
    }

    updateRouteInfo(routerObj: RouterObj): void {
        if (this.routeInfo && this.routeInfo.fullPath === routerObj.route.fullPath) return;
        this.routerInfo = routerObj.router;
        this.routeInfo = routerObj.route;
    }

    testHasRouteInfo(): boolean {
        try {
            return !!(this.routerInfo?.type && this.routeInfo?.fullPath);
        } catch (e) {
            return false;
        }
    }

    addTokenToIframeUrl(str: string): string {
        const token = window.localStorage.getItem('ISC_SSO_TOKEN');
        if (!token) {
            return str;
        }
        if (str.includes('token')) {
            return str.replace(/token=(.*)[^&]/, token);
        }
        if (str.includes('?')) {
            return str + `&token=${token}`;
        }
        str += `?token=${token}`;
        return str;
    }

    addRandomString(str: string): string {
        return `${str}&${Date.now()}`;
    }

    get desktopUrl(): string {
        if (!this.routerInfo?.type || !this.routeInfo?.fullPath) {
            return location.protocol + '//' + location.host + '/desktop' + this.getAppPath();
        }
        const prefix = this.getAppPath();
        let url = location.protocol + '//' + location.host + '/desktop' + prefix;

        const searchParams = new URLSearchParams('');
        searchParams.set('appT', this.routerInfo.type);
        searchParams.set('appU', this.routeInfo.fullPath);
        searchParams.set('appN', this._configs.code);
        const query = searchParams.toString();
        url += '?' + query;

        return url;
    }

    getAppPath(): string {
        switch (this._configs.type) {
            case AppType.DEFAULT_APP:
                return `/os/${this._configs.code}`;
            case AppType.THIRD_PARTY_APP:
                return `/app/${this._configs.code}`;
            case AppType.EXTERNAL_LINK_APP:
                return `/external-app/${this._configs.code}`;
            case AppType.LIGHT_APP:
                return `/light-app/${this._configs.code}`;
            case AppType.LOCAL_TEST_APP:
                return `/local-app/${this._configs.code}`;
            default:
                return `/${this._configs.code}`;
        }
    }

    getInitIframeUrl(): string {
        switch (this._configs.type) {
            case AppType.DEFAULT_APP:
                return this.getAppPath();
            case AppType.THIRD_PARTY_APP:
                return this.getAppPath();
            case AppType.EXTERNAL_LINK_APP:
                return this._configs.redirectUrl!;
            case AppType.LIGHT_APP:
                return this._configs.redirectUrl!;
            case AppType.LOCAL_TEST_APP:
                return this._configs.redirectUrl!;
            default:
                return `/${this._configs.code}`;
        }
    }

    static isAppUrlRight(deskApp: DeskApp): boolean {
        if ([AppType.EXTERNAL_LINK_APP, AppType.LIGHT_APP, AppType.LOCAL_TEST_APP].includes(deskApp.type)) {
            return /^(\/os|\/app|https?:\/)\//i.test(deskApp.redirectUrl || '');
        }
        return true;
    }

    setInstanceId(id: number): void {
        this.instanceId = id;
    }
}
